import React, { useState, useEffect, } from 'react';
import { Form, Button, Card, Row, Col } from 'react-bootstrap';
import { Modal, Table, Select } from 'antd';
import { updateReturns } from '../../../services/UploadService';
import moment from 'moment';


const ReturnsInputModal = (props) => {
    const [formValues, setFormValues] = useState({
        description: '',
        return_date: '',
        tenure: '',
        upload_docs: [],
        return_submitted: false,
        trigger_rate: 0,
        ice_name: '',
        iec_no: '',
    });

    const [newFile, setNewFile] = useState(null);
    const [files, setFiles] = useState([])
    const [deleteFiles, setDeleteFiles] = useState([]);
    const [selectedIECNo, setSelectedIECNo] = useState(props?.selectedIEC);
    const [iecName, setIECName] = useState(props?.iecName);

    const onFileDelete = (fileName) => {
        setDeleteFiles([...deleteFiles, fileName]);
        setFiles(files.filter((f) => f !== fileName))
    }

    const handleFileInputChange = (e) => {
        const { files } = e.target;
        if (files) {
            setNewFile(files

            );
        }
    }

    const handleInputChange = (e) => {
        const { name, value, checked, type } = e.target;
        if (type === 'checkbox') {
            setFormValues({
                ...formValues,
                [name]: checked,
            });
        } else {
            setFormValues({
                ...formValues,
                [name]: value,
            });
        }
    }

    const handleCancel = () => {
        setFormValues({});
        setFiles([])
        setDeleteFiles([])
        setNewFile(null)
        props?.handleClose() && props?.handleClose();

    };

    const handleIECSelection = (val) => {
        console.log(val)
        if (val) {
            let iec_no = val.split(";")[0];
            let iec_name = val.split(";")[1];
            setSelectedIECNo(iec_no)
            setIECName(iec_name)
            setFormValues({
                ...formValues,
                ice_name: iec_name,
                iec_no: iec_no
            })
        }
        else {
            setSelectedIECNo(null);
            setIECName('');
            setFormValues({
                ...formValues,
                ice_name: '',
                iec_no: ''
            })
        }
    }

    const handleUpdate = async () => {

        try {
            const formData = new FormData();

            formData.append('description', String(formValues.description));

            formData.append('return_date', formValues.return_date);

            formData.append('tenure', formValues.tenure);

            formData.append('trigger_rate', formValues.trigger_rate);

            formData.append('delete_files', deleteFiles);

            formData.append('return_submitted', formValues.return_submitted);

            formData.append('ice_no', formValues?.iec_no)

            if (newFile !== null && newFile?.length > 0) {
                for (let i = 0; i < newFile.length; i++) {
                    formData.append('new_files', newFile[i]);

                }
            } else {
                formData.append('new_files', []);

            }

            // Append any additional data or files if needed
            const token = localStorage.getItem('token');
            // Make the API call
            await updateReturns(formValues.returns_id, formData, token)

            props.handleClose();

        }
        catch (error) {
            errorFunction(error?.message ? error?.message : error);
        }
    };

    const errorFunction = (content) => {
        if (props?.errorFunction) {
            props.errorFunction(content)
        }
    };

    useEffect(() => {
        if (props.data) {
            const formattedDate = props.data.return_date ? moment(props.data.return_date).format('YYYY-MM-DD') : '';
            setFormValues({
                ...props.data,
                return_date: formattedDate
            });
            setFiles(props.data.upload_docs || props.data.file_path || []);
        }
    }, [props.data, props.title, props.open]);


    const columns = [
        {
            title: "File Name",
            dataIndex: "name",
            width: 450,
        },
        {
            title: "Action",
            dataIndex: "action",
            width: 100,
            render: (file) => {
                // Format the date to only show the date part, not the time
                return <button type='button' className='icon btn-icon' onClick={() => onFileDelete(file)}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                    <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                </svg></button>
            },
        },

    ]

    return (
        <div id="test-modal">
            <Modal
                title={"Edit " + props.title}
                width={"60%"}
                open={props.open}
                onCancel={handleCancel}
                footer={[
                    <Button key="submit" type="primary" className="cip-btn-submit" onClick={handleUpdate}>
                        Update
                    </Button>,
                ]}
            >
                <Card>
                    <Card.Body>
                        <hr className="hr-horizontal" />
                        <Form>
                            <Form.Group as={Row} className="mb-3" controlId="description">
                                <Form.Label column sm="2">Description*</Form.Label>
                                <Col sm="4">
                                    <Form.Control
                                        required
                                        type="text"
                                        name="description"
                                        placeholder='Enter Description'
                                        value={formValues.description}
                                        onChange={handleInputChange}
                                        style={!(formValues.description) ? { border: '1px solid var(--cip-danger)' } : undefined}
                                    />
                                </Col>

                                <Form.Label column sm="2">Select IEC </Form.Label>
                                <Col sm="4">
                                    <Select
                                        focus
                                        showSearch
                                        placeholder="Select IEC"
                                        filterOption={(input, option) =>
                                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                        }
                                        value={
                                            (props?.IECOptions || []).find(opt => opt.value && opt.value.split(';')[0] === formValues?.iec_no)?.value || formValues?.iec_no || undefined
                                        }
                                        onChange={handleIECSelection}
                                        allowClear
                                        options={props?.IECOptions}
                                        style={{ width: '300px', float: 'right' }}
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3" controlId="return_date">
                                <Form.Label column sm="2">Return date*</Form.Label>

                                <Col sm="4">
                                    <Form.Control
                                        required
                                        type="date"
                                        name="return_date"
                                        placeholder='Enter Return date'
                                        value={formValues.return_date}
                                        onChange={handleInputChange}
                                        style={!(formValues.return_date) ? { border: '1px solid var(--cip-danger)' } : undefined}
                                    />
                                </Col>

                                <Form.Label column sm="2">Tenure*</Form.Label>

                                <Col sm="4">
                                    <Form.Control
                                        required
                                        as="select"
                                        name="tenure"
                                        placeholder='Enter Tenure date'
                                        value={formValues.tenure}
                                        onChange={handleInputChange}
                                        style={!(formValues.tenure) ? { border: '1px solid var(--cip-danger)' } : undefined}
                                    >
                                        <option value="" disabled>Select Tenure</option>
                                        {(props.tenureOptions || []).map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </Form.Control>
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3" controlId="trigger_rate">
                                <Form.Label column sm="2">Alert trigger rate in days*</Form.Label>
                                <Col sm="4">
                                    <Form.Control
                                        required
                                        name="trigger_rate"
                                        placeholder='Enter Trigger rate'
                                        value={formValues.trigger_rate}
                                        onChange={handleInputChange}
                                        type="number"
                                        style={!(formValues.trigger_rate) ? { border: '1px solid var(--cip-danger)' } : undefined}
                                    />
                                </Col>

                                <Form.Label column sm="2">Return Submitted*</Form.Label>
                                <Col sm="4">
                                    <Form.Check
                                        name="return_submitted"
                                        type="checkbox"
                                        checked={formValues.return_submitted}
                                        value={formValues.return_submitted}
                                        onChange={handleInputChange}
                                        style={{ paddingTop: '8px' }}
                                    />
                                </Col>

                            </Form.Group>

                            <Form.Group as={Row} className="mb-3" controlId="upload_docs">
                                <Form.Label column sm="2">Upload Files</Form.Label>
                                <Col sm="10">
                                    <Form.Control

                                        multiple
                                        type="file"
                                        name="upload_docs"
                                        accept=".pdf, .xls, .xlsx, .jpeg, .png"
                                        onChange={handleFileInputChange}
                                    />
                                </Col>
                                <Col >
                                    <Form.Label column sm="2">Files</Form.Label>
                                    <Table
                                        style={{ width: '100%' }}
                                        columns={columns}
                                        dataSource={files.length > 0 ? files.map((file) => ({
                                            name: file,
                                            action: file
                                        })) : []}
                                        scroll={{ x: 'max-content' }}
                                    />
                                </Col>
                            </Form.Group>
                        </Form>
                    </Card.Body>
                </Card>
            </Modal>
        </div>
    )
}

export default ReturnsInputModal;